import React from "react";
import { defineMessages, useIntl } from "react-intl";

import { useCbtUpdateGuestCheckbox } from "shared/hooks/cbtUpdateGuestCheckbox";

import CustomCheckbox from "@components/Forms/Inputs/CustomCheckbox";

const { cbtUpdateGuest } = defineMessages({
  cbtUpdateGuest: {
    id: "CBTUpdateGuestCheckbox.updateCBTGuest",
  },
});

const CbtUpdateGuestCheckbox: React.FC<{
  indexPassenger: number;
}> = ({ indexPassenger }) => {
  const intl = useIntl();

  const { isChecked, handleCheck } = useCbtUpdateGuestCheckbox({
    indexPassenger,
  });

  return (
    <CustomCheckbox
      defaultMessage={intl.formatMessage(cbtUpdateGuest)}
      input={{ checked: isChecked, onChange: handleCheck }}
      testId={`update-guest-checkbox-${indexPassenger}`}
    />
  );
};

export default CbtUpdateGuestCheckbox;
